import React, { useEffect, useRef } from "react";
import { theme } from "antd";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useResumeStore } from "../../store/resumeStore";

const { useToken } = theme;

export default function AchievementsEditor() {
  const { token } = useToken();
  const resume = useResumeStore((s) => s.resume);
  const updateResume = useResumeStore((s) => s.updateResume);
  const quillRef = useRef(null);

  const quillModules = {
    toolbar: [
      ["bold", "italic"],
      [{ background: ["yellow", "red", "green", "blue"] }],
      [{ list: "bullet" }],
      ["clean"],
    ],
  };

  const quillFormats = ["bold", "italic", "background", "list", "bullet"];

  useEffect(() => {
    const editorRoot = quillRef.current?.getEditor?.()?.root;
    if (!editorRoot) return;

    editorRoot.setAttribute("spellcheck", "true");
    editorRoot.setAttribute("autocorrect", "on");
    editorRoot.setAttribute("autocapitalize", "sentences");
  }, [resume.achievements]);

  return (
    <div>
      {/* Title */}
      <h3
        style={{
          color: token.colorTextHeading,
          marginBottom: 16,
        }}
      >
        Achievements
      </h3>

      {/* Themed Wrapper */}
      <div
        style={{
          border: `1px solid ${token.colorBorder}`,
          borderRadius: 0,
          background: token.colorBgContainer,
        }}
        className="themed-quill"
      >
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={resume.achievements || ""}
          modules={quillModules}
          formats={quillFormats}
          placeholder="Add your achievements, awards, recognitions, milestones..."
          onChange={(value) => updateResume("achievements", value)}
          style={{
            height: 220,
          }}
        />
      </div>

      <style>
        {`
    .themed-quill .ql-toolbar {
      background: ${token.colorBgContainer};
      border-bottom: 1px solid ${token.colorBorder};
    }

    .themed-quill .ql-container {
      background: ${token.colorBgContainer};
      color: ${token.colorText};
    }

    .themed-quill .ql-editor {
      color: ${token.colorText};
      min-height: 180px;
    }

    /* 🔹 PLACEHOLDER THEME FIX */
    .themed-quill .ql-editor.ql-blank::before {
      color: ${token.colorTextPlaceholder} !important;
      font-style: italic;
      opacity: 0.7;
    }

    .themed-quill .ql-stroke {
      stroke: ${token.colorText};
    }

    .themed-quill .ql-fill {
      fill: ${token.colorText};
    }

    .themed-quill .ql-picker {
      color: ${token.colorText};
    }

    .themed-quill .ql-toolbar button:hover,
    .themed-quill .ql-toolbar button.ql-active {
      background: ${token.controlItemBgActive};
    }
  `}
      </style>
    </div>
  );
}
